import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Layout, { Container as _Container } from "./layout";
import logo from "../images/logo.svg";
import styled from "styled-components";

const Logo = styled.img`
  width: 125px;
  height: 33px;
  display: block;

  &:hover {
    opacity: 0.8;
    transition: 0.2s;
  }
`;

const LogoWrapper = styled.a`
  padding: 8px 0;
  display: inline-block;
`;

const HeaderWrapper = styled.header`
  margin-top: 20px;
  margin-bottom: 15px;

  @media (max-width: 552px) {
    margin-bottom: 0;
  }
`;

const Container = styled(_Container)`
  @media (max-width: 552px) {
    margin-bottom: 0;
  }
`;

const Header = ({ siteTitle }) => (
  <HeaderWrapper>
    <Container>
      <LogoWrapper href="https://mybook.ru/">
        <Logo src={logo} alt="" />
      </LogoWrapper>
    </Container>
  </HeaderWrapper>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
